import axios from "@/utils/request";
// 获取设备列表
export function GetEqpInfoList(data){
    return axios({
        url:'/isc_ems/isc/ems/EqpInfo/GetEqpList',
        method:'post',
        data
    })
}
// 设备分页列表（PC 端 EqpInfo/GetEqpPageList，返回 res.rows / res.total）
export function GetEqpPageList(data) {
    return axios({
        url: '/isc_ems/isc/ems/EqpInfo/GetEqpPageList',
        method: 'post',
        data,
    })
}
//获取有权限公司列表
export function GetAuthCompany() {
    return axios({
        url: '/isc_ems/isc/ems/Common/GetAuthCompany',
        method: 'GET',
    })
}

// 获取所有公司（与 PC 端 /isc/ems/EqpInfo/GetAllCompany 一致）
export function GetAllCompany() {
    return axios({
        url: '/isc_ems/isc/ems/EqpInfo/GetAllCompany',
        method: 'GET',
    })
}

// 获取故障树树形数据
export function GetFaultTree(data) {
  return axios({
    url: '/isc_ems/isc/ems/FaultTree/GetFaultTree',
    method: 'POST',
    data,
  })
}
// 新增维修工单（含扩展信息，事务插入）
export function InsertPmWo(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/InsertPmWo',
    method: 'post',
    data,
  })
}
//获取维修工单详情页数据
export function GetWoRepairDataH5(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepairWorkOrder/GetWoRepairDataH5',
    method: 'post',
    data,
  })
}
//获取维修工单流转记录
export function GetWorkOrderStepRecord(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepairWorkOrder/GetWorkOrderStepRecord',
    method: 'post',
    data,
  })
}

// 插入维修步骤记录
export function InsertWoStepRecord(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/InsertWoStepRecord',
    method: 'post',
    data,
  })
}

// 安排维修人员
export function SavePmWoAssign(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/SavePmWoAssign',
    method: 'post',
    data,
  })
}
// 修改维修人员
export function UpPmWoAssign(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/UpPmWoAssign',
    method: 'post',
    data,
  })
}
// 确认到场
export function ConfirmPmWoArrival(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/ConfirmPmWoArrival',
    method: 'post',
    data,
  })
}
// 获取维修人员列表
export function GetTeamEmp(data) {
  return axios({
    url: '/isc_ems/isc/ems/EquipmentTeamEmployee/GetTeamEmp',
    method: 'post',
    data,
  })
}
//确认故障信息
export function SaveRepairExtend(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/SaveRepairExtend',
    method: 'post',
    data,
  })
}
/// 保存维修记录
export function SaveRepairRecord(data) {
  return axios({
    url: '/isc_ems/isc/ems/WoRepairRecord/SaveRepairRecord',
    method: 'post',
    data,
  })
}
//根据维修工单ID获取关联的维修工单详情
export function GetPmWoByWoRelateRepairId(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/GetPmWoByWoRelateRepairId',
    method: 'post',
    data,
  })
}

//获取维修工单分页列表（绑定已有工单）
export function GetPmWoPageList(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/GetPmWoPageList',
    method: 'post',
    data,
  })
}

// 绑定已有工单
export function SubmitBindWo(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/SubmitBindWo',
    method: 'post',
    data,
  })
}

// 移除关联绑定
export function CleaRelateRepair(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/CleaRelateRepair',
    method: 'post',
    data,
  })
}

//获取工单的维修记录列表

export function GetWoRepairRecord(data) {
  return axios({
    url: '/isc_ems/isc/ems/WoRepairRecord/GetWoRepairRecord',
    method: 'post',
    data,
  })
}
//删除工单的维修记录
export function DelRepairRecord(data) {
  return axios({
    url: '/isc_ems/isc/ems/WoRepairRecord/DelRepairRecord',
    method: 'post',
    data,
  })
}

//获取维修工单分页列表（我的）
export function GetPmWoPageData(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepairWorkOrder/GetPmWoPageList',
    method: 'post',
    data,
  })
}
//获取待验收工单
export function GetAcceptanceTicketH5(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/GetAcceptanceTicketH5',
    method: 'post',
    data,
  })
}
//维修完成提交
export function CompleteRepairSubmit(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/CompleteRepairSubmit',
    method: 'post',
    data,
  })
}
//确认验收/取消工单
export function ConfirmAcceptance(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/ConfirmAcceptance',
    method: 'post',
    data,
  })
}

//判断是否为rme主管
export function IsRmeSupervisor(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/IsRmeSupervisor',
    method: 'post',
    data,
  })
}

//判断是否为mfg人
export function IsMfgMember(data) {
  return axios({
    url: '/isc_ems/isc/ems/EmergencyRepair/IsMfgMember',
    method: 'post',
    data,
  })
}

//获取角色权限
export function GetAdminInfo() {
  return  axios({
    url: '/isc_ems/isc/ems/Common/GetAdminInfo',
    method: 'get'
  })
}